import { AnalyticsEvent } from './AnalyticsEvent';

type BufferedEvent = {
  event: AnalyticsEvent;
  properties: object;
  timestamp: Date;
};

let buffer: BufferedEvent[] = [];

export const addEventToBuffer = (event: AnalyticsEvent, properties: object = {}) => {
  console.info(`Adding event to buffer: ${event.entity} ${event.action}`, properties);
  buffer.push({ event, properties, timestamp: new Date() });
};

export const getLastNBufferedEvents = (n: number): BufferedEvent[] => {
  if (buffer.length === 0) {
    return [];
  }
  const seen = new Set();
  const uniqueEvents: BufferedEvent[] = [];
  for (let i = buffer.length - 1; i >= 0; i--) {
    const eventName = `${buffer[i].event.entity} ${buffer[i].event.action}`;
    if (!seen.has(eventName)) {
      seen.add(eventName);
      uniqueEvents.push(buffer[i]);
    }
    if (uniqueEvents.length >= n) {
      break;
    }
  }
  return uniqueEvents.reverse();
};

export const clearBuffer = () => {
  buffer = [];
};
